import React, { useState, useEffect } from "react"
import { toast } from "react-toastify"

import { apiCall, url_base } from './../../../Helper'

import Footer from "../../components/Footer"
import Pagination from "../../components/Pagination"
import Loading from "../../components/Loading"
import News from './../../images/news.jpg'
import Arrow from './../../images/icons/drop-down.png'

const htmlToText = require('html-to-text')

export default () => {
  const [isLoading, setIsLoading] = useState(false)
  const [news, setNews] = useState([])
  const [page, setPage] = useState(1)
  const [pageCount, setPageCount] = useState(0)

  function getNews() {
    setIsLoading(true)
    apiCall({
      url: '/news/news',
      params: { start: (page - 1) * 10, end: 10 }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        setNews(res.data.news)
        setPageCount(Math.ceil(res.data.count / 10))
      }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  useEffect(() => {
    getNews()
    if (news.length > 0)
      document.getElementById('content-holder').scrollIntoView({ behavior: 'smooth' })
  }, [page])

  return (
    <div>
      <div className="px-64"
        style={{ height: 'calc(100vh - var(--top-nav-height))', backgroundAttachment: 'fixed', maxHeight: 700, backgroundImage: `url(${News})`, backgroundPosition: '0 85px', backgroundSize: '100%' }}>
        <div className="absolute" style={{
          bottom: 0,
          right: 'calc(50% - 22px)'
        }}>
          <button className="bd-none bg-none icon-button notifyMe" style={{ filter: 'drop-shadow(0px -4px 0px #464953)' }}
            onClick={() => document.getElementById('content-holder').scrollIntoView({ behavior: 'smooth' })}>
            <span className="bg-bg icon-mask thumb blocked" style={{
              WebkitMaskImage: `url(${Arrow})`,
              WebkitMaskSize: 'contain'
            }} />
          </button>
        </div>
      </div>
      <div id="content-holder" className="container pt-64">
        <section className="px-64 py-45">
          <div className="pb-45 text-center">
            <span>خبرهای مالیاتی</span>
            <h3 className="text-shadow font-20" style={{ marginRight: -20 }}>
              <img className="icon-sm ml-8" style={{ transform: 'rotate(90deg)' }} src={Arrow} alt="" />
              خبرهای مربوط به مالیات را در اختیارتان می گذاریم
            </h3>
          </div>

          <div className="news-items grid" style={{ gap: 64 }}>
            {news.map((news, index) => (
              <div key={index} className="news-item grid radius-8 overflow-hidden" style={{ backgroundColor: '#f1f1f1', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                <div className="p-32 pb-0">
                  <h3 className="mt-0 font-16 overflow-hidden iran-sans-light mb-16" style={{ height: 85, lineHeight: 2.3 }}>{news.title}</h3>
                  <div className="flexed justify-between px-16">
                    {/* <div className="font-11">
                      <span className="text-lighter">نویسنده: </span>
                      <span className="text-lighter">{news.user?.user_name}</span>
                    </div> */}
                    <div className="font-11">
                      <span className="text-lighter">تاریخ انتشار: </span>
                      <span className="text-lighter">{news.submit_date?.slice(0, 10)}</span>
                    </div>
                    {/* <div className="font-11">
                      <span className="text-lighter">تعداد نظرات: </span>
                      <span className="text-lighter">{news.valid_comments)}</span>
                    </div> */}
                  </div>
                  <p className="overflow-hidden font-13 text-lighter" style={{ lineHeight: 2.4, height: 154 }}>
                    {htmlToText.fromString(news.content?.slice(0, 512))}
                  </p>
                  <a target="_blank" href={`/news/list/${news.id_news}`} className="inline-blocked pr-4">
                    <span className="text-tomato font-10">مطالعه بیشتر</span>
                    <span className="text-tomato">←</span>
                  </a>
                </div>
                <div>
                  <img className="w-100 blocked force" style={{ height: 395 }}
                    src={url_base + news.image}
                    // src={Avatar}
                    alt="" />
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
      <div className="pt-16 pb-32">
        {!isLoading && <Pagination currentPage={page} count={pageCount} setPage={setPage} />}
      </div>
      <Footer />
      <Loading show={isLoading} full />
    </div>
  )
}
